export default "__VITE_ASSET__Ccq80Qzt__"